import { BaseApiService } from '@/shared/api/BaseApiService';

export interface Country {
  id: string;
  iso2: string;
  name: string;
  flagEmoji: string;
  phoneCode: string;
  currencyCode: string | null;
}

export interface StateGeo {
  id: string;
  code: string;
  name: string;
}

export interface DistrictGeo {
  id: string;
  code: string;
  name: string;
}

export class LocationsService extends BaseApiService {
  protected readonly resourcePath = 'geo';

  async getCountries(): Promise<Country[]> {
    const response = await this.get('/countries');
    return (response as { data: Country[] }).data ?? [];
  }

  async getStates(countryId: string): Promise<StateGeo[]> {
    const response = await this.get(`/states?country_id=${countryId}`);
    return (response as { data: StateGeo[] }).data ?? [];
  }

  async getDistricts(stateId: string): Promise<DistrictGeo[]> {
    const response = await this.get(`/districts?state_id=${stateId}`);
    return (response as { data: DistrictGeo[] }).data ?? [];
  }
}
